import getType from './get-type';
import mobileShow from './mobile-show';
import mobileHide from './mobile-hide';

/**
 * Creates an event listener for mobile menu click events.
 *
 * This function returns an event listener that toggles the visibility of the mobile menu.
 * It hides any sibling menus that are currently active and shows or hides the target menu
 * based on its current visibility.
 *
 * @param {HTMLElement} el - The element that triggers the click event.
 * @param {HTMLElement} menu - The menu element to show or hide.
 * @param {Object} params - Configuration parameters.
 * @param {Object} params.classMap - A map of CSS classes.
 * @param {string} params.classMap.hasMegaMenu - The CSS class indicating a mega menu.
 * @param {string} params.classMap.hasSubMenu - The CSS class indicating a sub-menu.
 * @param {string} params.classMap.hasMegaMenuActive - The CSS class indicating an active mega menu.
 * @param {string} params.classMap.hasSubMenuActive - The CSS class indicating an active sub-menu.
 * @param {string} params.classMap.megaMenu - The CSS class for the mega menu.
 * @param {string} params.classMap.subMenu - The CSS class for the sub-menu.
 * @param {Object} itemParams - Item-specific parameters.
 * @returns {Function} - The event listener function.
 */
export default function mobileClickEventListener(el, menu, params, itemParams) {
  return function () {
    const { classMap } = params;
    const { hasMegaMenu, hasSubMenu, hasMegaMenuActive, hasSubMenuActive, megaMenu, subMenu } = classMap;

    const $siblingInvokers =
      menu
        .closest(`${hasMegaMenu}, ${hasSubMenu}`)
        ?.parentNode.querySelectorAll(`${hasMegaMenu}${hasMegaMenuActive}, ${hasSubMenu}${hasSubMenuActive}`) || [];

    $siblingInvokers.forEach(($el) => {
      const $menu = $el.querySelector(`${megaMenu}, ${subMenu}`);
      const itemSettings = {
        activeItemClass: function () {
          return getType($el, params) === 'mega-menu' ? hasMegaMenuActive : hasSubMenuActive;
        },
      };

      mobileHide($el, $menu, params, itemSettings);
    });

    if (menu.offsetParent === null) {
      mobileShow(el, menu, params, itemParams);
    } else {
      mobileHide(el, menu, params, itemParams);
    }
  };
}
